module.exports = __webpack_public_path__ + "img/0Q3B1666_L.69329afd.webp";